










import {
  AdvisorNavigation,
  Component,
  ComponentStyle,
  ComponentStyleDefinition,
  Prop,
  Question,
  Vue
} from "@zoovu/runner-browser-api";
import QuestionHeadViewExtended from "./question-head.vue";
import PagesNavigationViewExtended from "./pages-navigation.vue";

@Component({
  components: {
    QuestionHeadViewExtended,
    PagesNavigationViewExtended
  }
})
export default class QuestionTopView extends Vue {
  @Prop()
  navigation: AdvisorNavigation;

  @Prop()
  question: Question;

  @ComponentStyle()
  componentStyle: ComponentStyleDefinition;
}
